import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogProps,
  Button,
  Text,
} from '@chakra-ui/react'
import { DecisionFragment } from '@gql'
import useWriteDecision from '../hooks/useWriteDecision'
import React, { useRef } from 'react'
import { Trans, useTranslation } from 'react-i18next'

interface Props
  extends Omit<AlertDialogProps, 'children' | 'leastDestructiveRef'> {
  decision: DecisionFragment
  onDelete?(): void
}

export default function DecisionDeleteModal({
  decision,
  onDelete,
  ...alertProps
}: Props) {
  const { t } = useTranslation()
  // Archiving is a write like any other: same door, same rule (GOUV-14)
  const writeDecision = useWriteDecision()
  const cancelRef = useRef<HTMLButtonElement>(null)

  const handleDelete = async () => {
    await writeDecision({ archivedAt: new Date().toISOString() }, decision.id)
    onDelete?.()
    alertProps.onClose()
  }

  return (
    <AlertDialog {...alertProps} leastDestructiveRef={cancelRef}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader>
            {t('DecisionDeleteModal.heading')}
          </AlertDialogHeader>

          <AlertDialogBody>
            <Text>
              <Trans
                i18nKey="DecisionDeleteModal.info"
                values={{ name: decision.title }}
                components={{ b: <strong /> }}
              />
            </Text>
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={alertProps.onClose}>
              {t('common.cancel')}
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3}>
              {t('common.delete')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
